import type { PitcherManagerResponse } from "@codesandbox/pitcher-client";
import type { CsbApi } from "environment-interface/csbApi";

export async function getPitcherInstance(
  csbApi: CsbApi,
  headers: Record<string, string>,
  {
    branchId,
    usePitcherManagerThroughApi,
    pitcherManagerURL,
  }: {
    branchId: string;
    usePitcherManagerThroughApi: boolean;
    pitcherManagerURL: string;
  },
): Promise<PitcherManagerResponse> {
  if (usePitcherManagerThroughApi) {
    try {
      return csbApi.rest.post({
        path: `/beta/sandboxes/branches/${branchId}/instance${
          pitcherManagerURL ? `?pitcherManagerURL=${pitcherManagerURL}` : ""
        }`,
        data: {},
        headers,
      });
    } catch {
      throw new Error(`something went wrong with the pitcher manager request`);
    }
  }

  const response = await fetch(
    `${
      // To improve DX (copy pasting url) we allow you to use a direct url to pitcher-manager, but
      // still support the direct correct url
      pitcherManagerURL.includes("/api/v1")
        ? pitcherManagerURL
        : pitcherManagerURL + "/api/v1"
    }/sandboxes/branches/${branchId}`,
    {
      headers: {
        ...headers,
        authorization: `Bearer ${csbApi.devJwt.get()}`,
      },
    },
  );

  if (response.status !== 200) {
    throw new Error(
      `manager request failed with status code ${response.status}`,
    );
  }

  const managerResponse = (await response.json()) as PitcherManagerResponse;

  return managerResponse;
}
